import React from 'react';
import { Statistic } from 'antd';
import { ArrowUpOutlined } from 'icons';
import { useEntryStatistics } from 'libs/hooks';
import { StyledFooter } from './styles';

const AppFooter = (): React.ReactElement => {
  const { totalEntriesFiled, isFeatureEnabled } = useEntryStatistics();

  return (
    <StyledFooter>
      {isFeatureEnabled && totalEntriesFiled ? (
        <Statistic
          title="Total US Entries Filed"
          value={totalEntriesFiled}
          valueStyle={{ color: '#3f8600' }}
          prefix={<ArrowUpOutlined />}
        />
      ) : null}
    </StyledFooter>
  );
};

export default AppFooter;
